import storage from '@/services/storage';

import convertToOrderItem from '@/helpers/convert-to-order-item';


async function stageUpsellItems({ rootGetters, commit }, upsellItems) {
  const menu = rootGetters['menu/menu'];

  const stagedOrderItems = storage.local.get('orderItemsStaged') || [];

  upsellItems.forEach((item) => {
    const formattedUpsellOrderItem = convertToOrderItem(item, menu);

    stagedOrderItems.push(formattedUpsellOrderItem);
  });

  storage.local.set('orderItemsStaged', stagedOrderItems);

  commit('orders/SET_STAGED_ORDER_ITEMS', stagedOrderItems, { root: true });
}

export { stageUpsellItems };
